import { connect } from 'react-redux';
import RequestLog from './RequestLog';

const mapStateToProps = (state: any) => ({
  isLoading: state.singleDigitalGateway.details.requestLog?.isLoading,
  total: state.singleDigitalGateway.details.requestLog.total,
  requests: state.singleDigitalGateway.details.requestLog.data,
  appId: state.administration.apps.details.settings.settings.id,
});

export default connect(
  mapStateToProps, null,
)(RequestLog);
